<template>
  <div>
    <div v-if="component404">
      <h5>Resource not found</h5>
    </div>
    <div v-if="!componentLoading" id="user" class>
      <div class="row mx-1">
        <div class="card w-100">
          <div class="card-body p-4">
            <div class="d-flex mb-3 align-content-center d-flex align-items-center">
              <i class="material-icons material-icons-title mr-2">person</i>
              <h2 class="card-title mb-0">Profile</h2>
            </div>
            <div class="row">
              <div class="col-12 col-md-4 d-flex flex-column">
                <img
                  class="mb-3"
                  src="../assets/user-profile-picture-placeholder.png"
                  style="width:100%; height:auto"
                />
                <div class="scenario-stats my-2 d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <i class="material-icons text-secondary">insert_chart</i>
                    <em>Scenarios Contributed:</em>
                    <router-link :to="{ name: 'view-user', params: { id: user.userId } }">
                      <em>{{ this.usersScenariosLength }}</em>
                    </router-link>
                  </div>

                  <div class="d-flex align-items-center">
                    <i class="material-icons text-secondary">star</i>
                    <em>Favourited:</em>
                    <span class="element-label">
                      <em>{{ this.numberOfTimesFavourited }}</em>
                    </span>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="material-icons text-secondary">stars</i>
                    <em>Been Favourited:</em>
                    <em>{{ this.numberOfTimesFavourited }}</em>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-8">
                <div class="row">
                  <div class="col-12 col-md-6 py-3">
                    <div class="d-flex justify-content-start align-items-center">
                      <i
                        class="favourite-icon material-icons -title mt-1 mr-2"
                      >insert_chart_outlined</i>
                      <h5 class="mt-4 mb-3">Contributed Scenarios</h5>
                    </div>
                    <div v-if="usersScenarios.length > 0">
                      <ol class="mini-scenarios list-group mb-3 ml-0">
                        <li
                          class="row scenario bg-light mx-2 p-3 d-flex"
                          v-for="scenario in usersScenarios"
                        >
                          <MiniScenario
                            :uuidId="scenario.uuid_id"
                            :deviceId="scenario.device_id"
                            :name="scenario.name"
                          ></MiniScenario>
                        </li>
                      </ol>
                    </div>
                    <div v-else class="alert alert-secondary" role="alert">
                      This user has not contributed any public scenarios yet.
                      <br />
                      <router-link to="/scenarios">See scenarios scontributed by others.</router-link>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 py-3">
                    <div class="d-flex justify-content-start align-items-center">
                      <i class="favourite-icon material-icons -title mt-1 mr-2">star</i>
                      <h5 class="mt-4 mb-3">Favourites</h5>
                    </div>
                    <div v-if="usersScenarios.length > 0">
                      <ol class="mini-scenarios list-group mb-3 ml-0">
                        <li
                          class="row scenario bg-light mx-2 p-3 d-flex"
                          v-for="scenario in favouriteScenarios"
                        >
                          <MiniScenario
                            :uuidId="scenario.uuid_id"
                            :deviceId="scenario.device_id"
                            :name="scenario.name"
                          ></MiniScenario>
                        </li>
                      </ol>
                    </div>
                    <div
                      v-else
                      class="alert alert-secondary"
                      role="alert"
                    >This user has not favourited any scenarios yet.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="componentLoading" class="please-wait">
      <PleaseWait></PleaseWait>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import ScenService from "../services/scenarios.service";
import { get } from "http";
import ScenarioObject from "../objects/ScenarioObject";
import UserObject from "../objects/UserObject";
import TagObject from "../objects/TagObject";
import MiniScenario from "../components/MiniScenario";
import PleaseWait from "../components/PleaseWait";

export default {
  name: "User",
  components: {
    MiniScenario
  },
  data: function() {
    return {
      componentLoading: true,
      component404: false,
      numberOfTimesFavourited: 0,
      user: {},
      favouriteScenarios: [],
      favouriteScenariosLength: 0,
      usersScenarios: {},
      usersScenariosLength: 0
    };
  },
  methods: {
    getUser(id) {
      this.componentLoading = true;
      UserService.getUserDetails(this.$route.params.id)
        .then(data => {
          this.user = data[0];
          this.getUsersPublicScenarios();
          let nameToDisplay = this.user.is_public ? this.user.username : "Anonymous";
          this.setRouteParams(
            "View User: " + nameToDisplay
          );
        })
        .catch(error => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });
    },

    getUsersPublicScenarios() {
      ScenService.getUsersPublicScenarios(this.user.id).then(data => {
        this.usersScenarios = data.scenarios;
        this.usersScenariosLength = data.count;
        this.usersScenarios.forEach(scenario => {
          this.numberOfTimesFavourited += scenario.number_favourites;
        });
        this.getUsersFavouritedScenarios();
      });
    },

    getUsersFavouritedScenarios() {
      ScenService.getUsersFavouritedScenarios(this.user.id).then(data => {
        data.forEach(element => {
          this.favouriteScenarios.push(element.scenario);
        });
        this.favouriteScenariosLength = favouriteScenarios.length;
        this.componentLoading = false;
      });
    },
    setRouteParams(param) {
      this.$route.meta.breadcrumb.label = param;
      this.$router.replace({ query: { temp: Date.now() } });
      this.$router.replace({ query: { temp: undefined } });
    }
  },

  watch: {
    "$route.params.id": function() {
      this.geUser(this.$route.params.id);
    }
  },

  beforeMount() {
    this.scenario = {};
    this.getUser();
  }
};
</script>

<style scoped>
.scenario {
  min-height: 100%;
}

.please-wait {
  height: 60vh;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}

.favourite-icon {
  font-size: 20px;
  color: #6c757d;
}

.scenario-icon {
  font-size: 20px;
  color: #6c757d;
}
</style>
